document.addEventListener('DOMContentLoaded', function () {

  var toggleBtns   = document.querySelectorAll('.sachet-toggle-btn[data-product-handle]');
  var purchaseZone = document.getElementById('nandaka-purchase-zone');
  var dataEl       = document.getElementById('nandaka-product-data');

  if (!toggleBtns.length || !purchaseZone || !dataEl) return;

  var productData;
  try { productData = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('Nandaka: bad product data', e); return; }

  var activeData = productData.current;

  // ── Pre-fetch and cache the OTHER product's zones on page load ───────────
  // This runs silently in the background so the toggle is instant when clicked
  var zoneCache = {};  // { handle: { purchaseZoneHTML, atcZoneHTML } }

  function prefetchProduct(handle) {
    if (zoneCache[handle]) return; // already cached
    fetch('/products/' + handle + '?variant=')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pz  = doc.getElementById('nandaka-purchase-zone');
        var atc = doc.getElementById('nandaka-atc-zone');
        zoneCache[handle] = {
          purchaseZoneHTML: pz  ? pz.innerHTML  : null,
          atcZoneHTML:      atc ? atc.innerHTML : null
        };
      })
      .catch(function (e) { console.warn('Nandaka prefetch failed:', handle, e); });
  }

  // Pre-fetch the other product immediately (runs in background, no UI impact)
  var otherHandle = productData.other.handle;
  prefetchProduct(otherHandle);

  // Also cache current product so switching back is instant too
  var currentHandle = productData.current.handle;
  zoneCache[currentHandle] = {
    purchaseZoneHTML: purchaseZone.innerHTML,
    atcZoneHTML: (document.getElementById('nandaka-atc-zone') || {}).innerHTML || null
  };

  // ── Apply prices, variant ID and selling_plan for a product ─────────────
  function applyProductData(data) {
    var variantInput = document.getElementById('nandaka-variant-input');
    if (variantInput) {
      variantInput.value = data.variantId;
      variantInput.dataset.productid = data.variantId;
    }

    var subWrapperHidden = document.querySelector('.pt_413_subscription_wrapper')
                            ?.classList.contains('pt_413_hidden');
    var isOnetime = subWrapperHidden;

    var form = document.querySelector('.ProductForm');
    var existingSellingPlan = form
      ? form.querySelector('input[name="selling_plan"]')
      : document.querySelector('input[name="selling_plan"]');

    if (isOnetime) {
      if (existingSellingPlan) existingSellingPlan.remove();
    } else {
      if (existingSellingPlan) {
        existingSellingPlan.value = data.sellingPlanId;
      } else {
        var newInput = document.createElement('input');
        newInput.type  = 'hidden';
        newInput.name  = 'selling_plan';
        newInput.value = data.sellingPlanId;
        if (form) form.appendChild(newInput);
      }
    }

    var displayPrice = isOnetime ? data.price : data.subPrice;
    var priceBtn = document.querySelector('.Quantity__PriceBtn');
    if (priceBtn) priceBtn.textContent = displayPrice;
    var priceSub = document.querySelector('.Quantity__PriceSub');
    if (priceSub) priceSub.textContent = displayPrice;
    var otpPrice = document.querySelector('.ProductOTP-Price');
    if (otpPrice) otpPrice.textContent = data.price;
  }

  function updateStickyBar(data) {
  // Desktop
  var otpPrice         = document.getElementById('sticky-otp-price');
  var subPrice         = document.getElementById('sticky-sub-price');
  var otpCompare       = document.getElementById('sticky-otp-compare-price');
  // Mobile
  var otpPriceMobile   = document.getElementById('sticky-otp-price-mobile');
  var subPriceMobile   = document.getElementById('sticky-sub-price-mobile');
  var otpCompareMobile = document.getElementById('sticky-otp-compare-price-mobile');

  if (otpPrice)         otpPrice.innerHTML         = '<strong>' + data.price + '</strong>';
  if (subPrice)         subPrice.innerHTML         = '<strong>' + data.subPrice + '</strong>';
  if (otpCompare)       otpCompare.innerHTML       = '<strong>' + data.price + '</strong>';
  if (otpPriceMobile)   otpPriceMobile.textContent = data.price;
  if (subPriceMobile)   subPriceMobile.textContent = data.subPrice;
  if (otpCompareMobile) otpCompareMobile.textContent = data.price;
}

  window.nandakaPriceOverride = function (data) {
    applyProductData(data);
    setTimeout(function () { applyProductData(data); }, 150);
  };

  // ── Sachet toggle click — instant swap from cache ────────────────────────
  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {

      if (btn.classList.contains('is-active')) return;

      toggleBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var handle = btn.dataset.productHandle;
      activeData = (handle === productData.current.handle)
                     ? productData.current
                     : productData.other;

      var cached = zoneCache[handle];

      if (cached) {
        // ✅ Instant — no fetch needed, use cached HTML
        if (cached.purchaseZoneHTML !== null) {
          purchaseZone.innerHTML = cached.purchaseZoneHTML;
        }
        var liveAtc = document.getElementById('nandaka-atc-zone');
        if (liveAtc && cached.atcZoneHTML !== null) {
          liveAtc.innerHTML = cached.atcZoneHTML;
        }
        setTimeout(function () {
          if (typeof window.initPt413 === 'function') window.initPt413();
          window.nandakaPriceOverride(activeData);
          updateStickyBar(activeData);
        }, 50);
      } else {
        // Cache miss (prefetch not done yet) — fetch normally then cache
        purchaseZone.style.opacity       = '0.4';
        purchaseZone.style.pointerEvents = 'none';
        fetch('/products/' + handle + '?variant=')
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var pz  = doc.getElementById('nandaka-purchase-zone');
            var atc = doc.getElementById('nandaka-atc-zone');
            zoneCache[handle] = {
              purchaseZoneHTML: pz  ? pz.innerHTML  : null,
              atcZoneHTML:      atc ? atc.innerHTML : null
            };
            if (pz) purchaseZone.innerHTML = pz.innerHTML;
            var liveAtc = document.getElementById('nandaka-atc-zone');
            if (liveAtc && atc) liveAtc.innerHTML = atc.innerHTML;
            setTimeout(function () {
              if (typeof window.initPt413 === 'function') window.initPt413();
              window.nandakaPriceOverride(activeData);
            }, 50);
          })
          .catch(function (e) { console.error('Nandaka: swap failed', e); })
          .finally(function () {
            purchaseZone.style.opacity       = '';
            purchaseZone.style.pointerEvents = '';
          });
      }

      document.dispatchEvent(new CustomEvent('nandaka:productSwapped', {
        detail: { handle: handle, data: activeData }
      }));
    });
  });

  // ── Sync price + selling_plan when subscribe/onetime toggle changes ───────
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.pt_413_toggle_input_one_time, .pt_413_toggle_input_subscription, .pt_413_onetime_left_lower_cta')) return;
    setTimeout(function () { applyProductData(activeData);updateStickyBar(activeData); }, 50);
  });

});